import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

import { useDispatch } from 'react-redux';
import { MACHINE_ENVIRONMENT, RECAPTCHA_ENABLED } from '../config/constant';
import { getSettingPersist } from '../helpers/misc';
import { api_call } from '../helpers/untils';

const RECAPTCHA_DEFAULT_VALUE = "xxxxxxxxxxxxxxxxx"
const CaptchaBox = (props) => {
  const { recaptcha, setRecaptcha, captchaTimestamp, captchaKey = "", defaultEnabled = false } = props
  const dispatch = useDispatch();

  const captchaRef = useRef(null)
  const setCaptchaRef = (ref) => {
    if (ref) {
      captchaRef.current = ref
    }
  }
  const resetCaptcha = () => {
    // maybe set it till after is submitted
    if (captchaRef && captchaRef.current) {
      captchaRef.current.reset();
    }
  }

  const [recaptchaKey, setRecaptchaKey] = useState("")
  const loadRecaptchaKey = async () => {
    const response = await api_call('/api/get-env-info');
    if (response.ok) {
      const apiResObj = await response.json();
      setRecaptchaKey(apiResObj['RECAPTCHA_KEY']);
    }
  }

  useEffect(() => {
    if (RECAPTCHA_ENABLED === "false") {
      setRecaptcha(RECAPTCHA_DEFAULT_VALUE)
    } else {
      loadRecaptchaKey()
    }
  }, [])

  const [captchaEnabled, setCaptchaEnabled] = useState(false)
  const checkCaptchaEnabled = () => {
    const captchaSettingEnabledValue = getSettingPersist(captchaKey, defaultEnabled)
    console.log("captchaSettingEnabledValue", captchaSettingEnabledValue)
    if (captchaSettingEnabledValue) { // show captcha
      setCaptchaEnabled(true)
      setRecaptcha((MACHINE_ENVIRONMENT === 'dev' || MACHINE_ENVIRONMENT === 'test') ? RECAPTCHA_DEFAULT_VALUE : "") //recaptcha
      if (window && window.grecaptcha) {
        resetCaptcha()
      }
    }
    else { // don't show captcha
      setCaptchaEnabled(false)
      setRecaptcha(RECAPTCHA_DEFAULT_VALUE)
    }
  }

  useEffect(() => {
    checkCaptchaEnabled(captchaKey)
  }, [captchaKey, captchaTimestamp])

  const onChange = (value) => {
    //console.log("ReCAPTCHA onchange::::", value);
    setRecaptcha(value);
  }

  const onExpired = () => {
    console.log("ReCAPTCHA onExpired::::");
    setRecaptcha((MACHINE_ENVIRONMENT === 'dev' || MACHINE_ENVIRONMENT === 'test') ? RECAPTCHA_DEFAULT_VALUE : "")
  }

  return (
    <>
      {
        (RECAPTCHA_ENABLED === "false") ? (
          <></>
        ) : (
          <>
            {
              (captchaEnabled && recaptchaKey) ? (
                <>
                  <ReCAPTCHA
                    ref={(r) => setCaptchaRef(r)}
                    sitekey={recaptchaKey}
                    onChange={onChange}
                    onExpired={onExpired}
                  />
                </>
              ) : (
                <></>
              )
            }
          </>
        )
      }
    </>
  );
};

export default CaptchaBox;
